import { useMutation } from '@tanstack/react-query';
import {
  EInvoiceAccountsService,
  UpdateHiloEinvoiceAccountDto,
} from 'services/openapi';

type UpdateEInvoiceAccountMutationVariables = UpdateHiloEinvoiceAccountDto & {
  accountId: string;
};

export const useUpdateEInvoiceAccountMutation = () => {
  const { isLoading, error, data, isError, isSuccess, mutate, mutateAsync } =
    useMutation<any, Error, UpdateEInvoiceAccountMutationVariables>({
      mutationFn: (variables: UpdateEInvoiceAccountMutationVariables) => {
        const { accountId, ...payload } = variables;
        return EInvoiceAccountsService.einvoiceAccountControllerUpdateHiloAccount(
          accountId,
          payload,
        );
      },
    });

  return {
    isLoading,
    isSuccess,
    error,
    data,
    isError,
    mutate,
    mutateAsync,
  };
};
